import { onMounted, ref, Ref } from '@vue/composition-api'
import { createVue } from '@/lib/utils'

const Vue = createVue()
const WIDGET_URL = '/eki-configurator-ui.min.js'

export function useLoadConfigurator() {
  const isLoading = ref(false)
  const error: Ref<null | unknown> = ref(null)

  onMounted(async () => {
    if (document.querySelector(`script[src="${WIDGET_URL}"]`)) {
      return
    }
    isLoading.value = true;

    // Save the current window.Vue
    (window as any).Vue = Vue
    const oldVue = (window as any).Vue

    const widget = document.createElement('script')
    widget.setAttribute('src', WIDGET_URL)
    widget.async = true
    widget.defer = true

    widget.onload = function() {
      // Restore window.Vue after loading
      (window as any).Vue = oldVue
      isLoading.value = false
    }
    widget.onerror = function(e) {
      (window as any).Vue = oldVue
      isLoading.value = false
      error.value = error
      console.error(e)
    }

    document.head.appendChild(widget)

    return {
      isLoading,
      error
    }
  })
}
